module.exports = __webpack_public_path__ + "static/media/ABENT3.crop_thumb.3bbdbdad.jpg";